import clsx from 'clsx'
import React from 'react'
import useStyles from './PrimaryButton.styles'
import { PrimaryButtonProps } from './PrimaryButtonProps'

const PrimaryButton: React.FC<PrimaryButtonProps> = ({
  href,
  className,
  children,
  isPrimary
}) => {
  const classes = useStyles()
  return (
    <a href={href} className={classes.link}>
      <div
        className={clsx(
          classes.button,
          // isPrimary could be true, false or null
          isPrimary === false ? classes.secondaryButton : classes.primaryButton,
          className
        )}
      >
        {children}
      </div>
    </a>
  )
}

export default PrimaryButton
